import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { ElementType } from "react";
import { useTranslation } from "react-i18next";
import { useBlocker } from "react-router-dom";

export default function withConfirmOnLeave<P>(WrappedComponent: ElementType) {
  return function Wrapper(passThroughProps: P) {
    const { t } = useTranslation();
    const blocker = useBlocker(
      ({ currentLocation, nextLocation }) =>
        currentLocation.pathname !== nextLocation.pathname,
    );
    return (
      <>
        <WrappedComponent {...passThroughProps} />
        <Modal
          isOpen={blocker.state === "blocked"}
          onClose={blocker.reset ?? (() => null)}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t("common.labels.leaving_page")}</ModalHeader>
            <ModalCloseButton onClick={blocker.reset} />
            <ModalBody>
              <Text>{t("common.labels.leaving_page_message")}</Text>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="red" mr={3} onClick={blocker.proceed}>
                {t("common.buttons.confirm")}
              </Button>
              <Button colorScheme="gray" onClick={blocker.reset}>
                {t("common.buttons.close")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  };
}
